import { Flex } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const StyledIconBox = styled(Flex)`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.BLUE_80};
`
